module.exports = __webpack_public_path__ + "static/media/cash.17e4420a.svg";